import { StoreApi, useStore } from 'zustand';

import { WishlistFiltrationGroupType } from '@notino/shared/definitions/types';

import { useWishlistStore } from '@containers/WishList/store';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { trackCheckboxFiltration } from '../../tracking';

type Params = {
  groupType: WishlistFiltrationGroupType;
  store: StoreApi<{
    selectedItems: Array<{
      name: string;
      navigationValue: number;
    }>;
  }>;
};

export const useMultiSelectList = ({ groupType, store }: Params) => {
  const { getTimeFromInit } = useTrackingContext();

  const { selectedItems } = useStore(store);
  const filter = useWishlistStore((x) => x.filtration).find(
    (x) => x.groupType === groupType
  );

  const isChecked = (item: { name: string; navigationValue: number }) => {
    return selectedItems.some(
      (x) => x.navigationValue === item.navigationValue
    );
  };

  const onChange = (
    checked: boolean,
    item: { name: string; navigationValue: number }
  ) => {
    trackCheckboxFiltration({
      timing: getTimeFromInit(),
      action: checked ? 'filtration_used' : 'filtration_removed',
      section: filter?.groupName ?? '',
      name: item.name,
      type: groupType,
    });

    store.setState({
      selectedItems: checked
        ? selectedItems.concat(item)
        : selectedItems.filter(
            (x) => x.navigationValue !== item.navigationValue
          ),
    });
  };

  return {
    selectedItems,
    filter,
    isChecked,
    onChange,
  };
};
